// src/components/ContactForm.js
import React, { useState } from "react";
import Turnstile from "react-turnstile";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY; // already in your .env

export default function ContactForm() {
  const [token, setToken] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      setStatus("Please complete the captcha.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_WORKER_URL}`, // "https://contact.squarespherestudios.com/api/contact"
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name: e.target.name.value,
            email: e.target.email.value,
            message: e.target.message.value,
            "cf-turnstile-response": token,
          }),
        }
      );
      if (res.ok) {
        setStatus("Thanks! We’ll be in touch.");
        e.target.reset();
        setToken(null);
      } else {
        setStatus("Submission failed, try again.");
      }
    } catch {
      setStatus("Network error, try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form className="space-y-4 w-full max-w-md" onSubmit={handleSubmit}>
      <input
        name="name"
        type="text"
        placeholder="Name"
        className="w-full p-2 rounded bg-gray-900 text-white"
        required
      />
      <input
        name="email"
        type="email"
        placeholder="Email"
        className="w-full p-2 rounded bg-gray-900 text-white"
        required
      />
      <textarea
        name="message"
        rows="4"
        placeholder="Message"
        className="w-full p-2 rounded bg-gray-900 text-white"
        required
      />
      {/* Turnstile widget */}
      <Turnstile
        sitekey={SITE_KEY}
        onSuccess={(tok) => setToken(tok)}
        onExpire={() => setToken(null)}
        className="my-2"
        options={{ theme: "auto" }}
      />
      <button
        type="submit"
        disabled={submitting}
        className="w-full py-2 bg-purple-600 hover:bg-purple-700 rounded text-white disabled:opacity-50"
      >
        {submitting ? "Sending…" : "Send"}
      </button>
      {status && <p className="text-sm text-gray-300">{status}</p>}
    </form>
  );
}
